// const production = {
//   API_URL: 'https://api.acadatech.co.uk/production',
//   UserPoolId: 'eu-west-2_Xg92ZNIUh',
//   ClientId: '76m39eackicn39vjp6ui52etpr',
//   IdentityPoolId: 'eu-west-2:577531b3-ff9f-49bb-a13c-36d5165139aa',
//   GA: 'UA-134208651-3',
//   name: 'production',
//   CognitoDomain: 'https://auth.acadatech.com',
// };

// const staging = {
//   API_URL: 'https://api.acadatech.co.uk/staging', //'https://zc0mg97a7c.execute-api.eu-west-2.amazonaws.com/staging',
//   UserPoolId: 'eu-west-2_kDOdLvm9e',
//   ClientId: '36mjsvftessisc4je1d2ompvla',
//   IdentityPoolId: 'eu-west-2:5498a41c-655a-48bb-bcd8-87dceb783b51',
//   GA: 'UA-134208651-2',
//   name: 'staging',
//   CognitoDomain: 'https://acada-staging.auth.eu-west-2.amazoncognito.com',
// };

const dev = {
  API_URL: 'https://api.acadatech.co.uk/development',
  UserPoolId: 'eu-west-2_Uj9IoD8ex',
  ClientId: 'u2tfs1r46rhcllf4pr8j9bo94',
  IdentityPoolId: 'eu-west-2:aaf3264f-9eab-4724-bbd5-9faff47b3aa3',
  GA: 'UA-134208651-2',
  name: 'dev',
  CognitoDomain: 'https://acada-dev.auth.eu-west-2.amazoncognito.com',
};
export default dev;
